// extracted by mini-css-extract-plugin
module.exports = {"section":"main-content_section__4rLCy"};